import classnames from "classnames";
import { Link } from "gatsby";
import noScroll from "no-scroll";
import React, { useRef, useState, useEffect } from "react";
import FocusLock from "react-focus-lock";

import UstwoLogo from "../../assets/UstwoLogo";
import { useOnClickOutside, useScrollPosition, useWindowSize, useScrollDirection } from "../../utils/hooks";
import * as styles from "./Header.module.css";
import MobileNavButton from "./MobileNavButton";

const Header = ({ hideNav, hideLogo, tokyo, location, invertLogo, background, invertWhite }) => {
  /* Mobile nav */
  const [open, setOpen] = useState(false);
  const headerRef = useRef();

  const toggleMobileMenu = (bool) => {
    if (bool) {
      noScroll.on();
    } else {
      noScroll.off();
    }
    setOpen(bool);
  };

  useOnClickOutside(headerRef, () => toggleMobileMenu(false));

  const windowHeight = useWindowSize().height;
  const scrollY = useScrollPosition();
  // const scrollPages = Math.round((scrollY / windowHeight) * 100) / 100;

  const scrollDirection = useScrollDirection();

  const [scrollPages, setScrollPages] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    setScrollPages(Math.round((scrollY / windowHeight) * 100) / 100);
    setIsScrolled(scrollY > 0);
  });

  /* Classes */
  const headerClasses = classnames(styles.header, {
    [styles.hideNav]: hideNav || (tokyo && scrollPages < 0.9),
    [styles.hideLogo]: hideLogo || (tokyo && scrollPages < 0.9),
    [styles.headerWrapperMenuOpen]: open,
    [styles.hidden]: scrollDirection === "down" && isScrolled,
    [styles.scrolledUp]: scrollDirection === "up" && isScrolled,
    [styles.atTop]: !isScrolled,
    [styles.background]: background,
    [styles.invertWhite]: invertWhite
  });
  const navClasses = classnames(styles.navWrapper, {
    [styles.menuOpen]: open,
  });

  const content = (
    <header className={headerClasses} ref={headerRef}>
      <div className={styles.inner}>
        <a className={styles.skipLink} href="#main-content">Skip to content</a>

        <Link
          to={tokyo ? "/tokyo/" : "/"}
          className={classnames(styles.logo, {
            [styles.logoInverted]: (invertLogo && !isScrolled)
          })}
          onClick={
            () => {
              toggleMobileMenu(false)
              window.rybbit?.event("Menu to Home", {
                from: location?.pathname || "unknown"
              })
            }
          }
        >
          <UstwoLogo />
        </Link>
        
        {hideNav ? <></> : (
          <div className={styles.mobileNavButton}>
            <MobileNavButton
              toggleMobileMenu={toggleMobileMenu}
              open={open}
              aria-controls="nav"
              invert={(scrollDirection === "up" && isScrolled) || invertWhite}
            />
          </div>
        )}

        {tokyo ? <></> : (
          <div className={navClasses}>
            <nav className={styles.nav} id="nav">
              <ul>
                {open && (
                  <li>
                    <Link
                      className={styles.navLink}
                      to="/"
                      onClick={
                        () => {
                          toggleMobileMenu(false)
                          window.rybbit?.event("Menu to Home", {
                            from: location?.pathname || "unknown"
                          })
                        }
                      }
                      activeClassName={styles.activeLink}
                      partiallyActive
                    >
                      Home
                    </Link>
                  </li>
                )}
                <li>
                  <Link
                    className={styles.navLink}
                    to="/what-we-do/"
                    onClick={
                      () => {
                        toggleMobileMenu(false)
                        window.rybbit?.event("Menu to What we do", {
                          from: location?.pathname || "unknown"
                        })
                      }
                    }
                    activeClassName={styles.activeLink}
                    partiallyActive
                  >
                    What we do
                  </Link>
                </li>
                <li>
                  <Link
                    className={styles.navLink}
                    to="/work/"
                    onClick={
                      () => {
                        toggleMobileMenu(false)
                        window.rybbit?.event("Menu to Work", {
                          from: location?.pathname || "unknown"
                        })
                      }
                    }
                    activeClassName={styles.activeLink}
                    partiallyActive
                  >
                    Work
                  </Link>
                </li>
                <li>
                  <Link
                    className={styles.navLink}
                    to="/ai/"
                    onClick={
                      () => {
                        toggleMobileMenu(false)
                        window.rybbit?.event("Menu to AI", {
                          from: location?.pathname || "unknown"
                        })
                      }
                    }
                    activeClassName={styles.activeLink}
                    partiallyActive
                  >
                    AI
                  </Link>
                </li>
                <li>
                  <Link
                    className={styles.navLink}
                    to="/blog/"
                    onClick={
                      () => {
                        toggleMobileMenu(false)
                        window.rybbit?.event("Menu to Insights", {
                          from: location?.pathname || "unknown"
                        })
                      }
                    }
                    activeClassName={styles.activeLink}
                    partiallyActive
                  >
                    Insights
                  </Link>
                </li>
                <li>
                  <Link
                    className={styles.navLink}
                    to="/our-story/"
                    onClick={
                      () => {
                        toggleMobileMenu(false)
                        window.rybbit?.event("Menu to Our story", {
                          from: location?.pathname || "unknown"
                        })
                      }
                    }
                    activeClassName={styles.activeLink}
                    partiallyActive
                  >
                    Our story
                  </Link>
                </li>
                <li>
                  <Link
                    className={styles.navLink}
                    to="/join-us/"
                    onClick={
                      () => {
                        toggleMobileMenu(false)
                        window.rybbit?.event("Menu to Join us", {
                          from: location?.pathname || "unknown"
                        })
                      }
                    }
                    activeClassName={styles.activeLink}
                    partiallyActive
                  >
                    Join us
                  </Link>
                </li>
                <li>
                  <Link
                    className={styles.navLink}
                    to="/contact-us/"
                    onClick={
                      () => {
                        toggleMobileMenu(false)
                        window.rybbit?.event("Menu to Contact", {
                          from: location?.pathname || "unknown"
                        })
                      }
                    }
                    activeClassName={styles.activeLink}
                    partiallyActive
                  >
                    Contact us
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </header>
  );

  if (open) {
    return (
      <FocusLock disabled={!open}>
        {content}
      </FocusLock>
    );
  }
  return content;

};

export default Header;
